// Import action type constants
import { ReduxEvent } from "./Constants";

// Define the initial shape and default values of the state
const initialState = {
  loading: true, // Indicates if data or app is still loading
  signedIn: false, // Indicates if the user is currently signed in
  useExternalDataSet: false, // Flag to determine if external data should be used
  personaParams: {
    // Object to store persona-related parameters
    country: "",
    ethnicity: "",
    hairtype: "",
    damageLevel: "",
    age: "",
  },
  selectedPersona: "", // Stores the currently selected persona ID or name
};

// The main reducer function to manage application state updates based on dispatched actions
const MainReducer = (state = initialState, action) => {
  const { data, type } = action; // Destructure action for cleaner usage

  switch (type) {
    // Handle loading state updates
    case ReduxEvent.LOADING:
      return {
        ...state,
        loading: data.loading,
      };

    // Update state when user signs in successfully
    case ReduxEvent.SIGNIN_SUCCESS:
      return {
        ...state,
        signedIn: data.signedIn,
      };

    // Update state when user signs out successfully
    case ReduxEvent.SIGNOUT_SUCCESS:
      return {
        ...state,
        signedIn: data.signedIn,
      };

    // Toggle or set whether to use external data source
    case ReduxEvent.USE_EXTERNAL_DATA_SET:
      return {
        ...state,
        useExternalDataSet: data.useExternalDataSet,
      };

    // Update the persona parameters in the state
    case ReduxEvent.PERSONA_PARAMS:
      return {
        ...state,
        personaParams: data.personaParams,
      };

    // Set the selected persona in the state
    case ReduxEvent.SELECTED_PERSONA:
      return {
        ...state,
        selectedPersona: data.selectedPersona,
      };

    // Return current state by default if action type doesn't match any case
    default:
      return state;
  }
};

// Export the reducer to be combined with others in the Redux store
export default MainReducer;
